import { chathistoryConstants } from '../constants';
import { chathistoryService } from '../services';
import { showToast } from '../services/toast';

export const chathistoryActions = {
  fetchUserSelections,
  getGamestatHistory
};

function fetchUserSelections(classId) {
  return dispatch => {

    return chathistoryService.fetchUserSelections(classId)
      .then(
        response => {
          return response.data;
        },
        error => {
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

}

function getGamestatHistory(classId) {
  return dispatch => {

    return chathistoryService.getGamestatHistory(classId)
      .then(
        response => {
          return response.data;
        },
        error => {
          if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
        }
      );
  };

}
